import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from '@reach/router';
import HiliteSlider from './HiliteSlider';

class Hilite extends Component{

  constructor(props){
    super(props);
  }

  render(){
    //if(!this.props.hot && !this.props.hotbig) return (<></>);
    return(
      <>
      <div className="home-hlite">
        <div className="home-h-hot"><h4>HOT!</h4></div>
        <div className="home-h-hot h3shadow"><h4>HOT!</h4></div>
        {/* <div className="container">
          <div className="hlite-top">
            <Link to={ this.props.hotbig.url }>
            <img src={ this.props.hotbig.image } />
              {this.props.hotbig.playicon &&
              <img className="btn-play-video" src="https://app.triyakom.com/artist_portal/old/btn-play-video.svg"/>
              }
            <div className="hlite-grad"></div>
            <div className="hlite-top-text">{ this.props.hotbig.title }</div>
            </Link>
          </div>
        </div> */}
        <div className="hlite-slider">
          <HiliteSlider data={this.props.hot.items} />
        </div>
      </div>
      </>
    );
  }
}

export default Hilite;
